export const setAdminSecurityData = (model, setModel, ele, property) =>{
    let newData = Object.assign({}, model);
    newData[property] = ele.target.value;
    setModel(newData);
}